export const FETCH_USER_CHECKOUTS_HISTORY = 'FETCH_USER_CHECKOUTS_HISTORY';
